<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Transferir paquete</h3>
  </div>
  <hr />

  <div class="d-grip gap-1 d-md-flex justify-content-md-end mb-3">
    <a [routerLink]="['/packages/list']" class="btn btn-outline-success">
      <i class="bi bi-arrow-left-circle"></i>
      Regresar a lista de paquetes
    </a>
  </div>
  <hr />

  <div class="col-sm-12 col-md-12 col-lg-12 mx-auto">
    <ngb-alert
      #selfClosingAlert
      type="danger"
      *ngIf="message != '' && flagErrors"
    >
      {{ message }}
    </ngb-alert>
    <ngb-alert
      #selfClosingAlert
      type="success"
      *ngIf="message != '' && isSaved"
    >
      {{ message }}
    </ngb-alert>

    <form
      [formGroup]="transferPackage"
      (ngSubmit)="transferPackages()"
      novalidate
    >
      <div class="accordion" id="transfer_session">
        <div class="accordion-item">
          <h2 class="accordion-header" id="package-information">
            <button
              class="accordion-button color-header-collapse"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              disabled
            >
              <span class="color-text"> Transferencia del Paquete </span>
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div class="row">
                <div class="form-floating mb-3 mt-2 col-md-12">
                  <select
                    #sellsValue
                    name="officeId"
                    id="officeId"
                    formControlName="officeId"
                    class="form-select"
                    aria-label="Selecciona una sucursal"
                    (change)="officeSelected($event)"
                    required
                    [ngClass]="{
                      'is-invalid': submitted && f.officeId!.errors,
                      'is-valid': submitted && !f.officeId!.errors
                    }"
                  >
                    <option value="">Seleccione una sucursal</option>
                    <option
                      value="{{ office.id }}"
                      *ngFor="let office of offices"
                    >
                      {{ office.name }}
                    </option>
                  </select>
                  <label for="officeId" class="ms-2">
                    Selecciona una sucursal
                  </label>
                </div>
              </div>
              <div class="row">
                <input
                  type="hidden"
                  name="userId"
                  id="userId"
                  class="form-control"
                  required
                  formControlName="userId"
                />
                <select2
                  [data]="users"
                  displaySearchStatus="always"
                  style="width: 100%"
                  placeholder="Clientes *"
                  resettable
                  listPosition="below"
                  formControlName="userTempId"
                  styleMode="material"
                  noResultMessage="Cliente no encontrado"
                  (update)="setDataToUsers($event)"
                  [ngClass]="{
                    'is-invalid': submitted && f.userTempId.errors,
                    'is-valid': submitted && !f.userTempId.errors
                  }"
                ></select2>
              </div>
              <div class="row">
                <input
                  type="hidden"
                  name="cabinId"
                  id="cabinId"
                  class="form-control"
                  required
                  formControlName="cabinId"
                />
                <select2
                  [data]="cabins"
                  displaySearchStatus="always"
                  style="width: 100%"
                  placeholder="Cabinas *"
                  resettable
                  listPosition="below"
                  formControlName="cabinTempId"
                  styleMode="material"
                  noResultMessage="Cabina no encontrado"
                  (update)="setDataToCabins($event)"
                  [ngClass]="{
                    'is-invalid': submitted && f.cabinTempId.errors,
                    'is-valid': submitted && !f.cabinTempId.errors
                  }"
                ></select2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 mt-2 d-grip gap-2 d-md-flex justify-content-md-end">
        <button
          type="button"
          class="btn btn-danger"
          (click)="resetTransferForm()"
        >
          <i class="bi bi-eraser"></i>
          Limpiar Informaci&oacute;n
        </button>
        <button
          type="submit"
          class="btn btn-success"
          [disabled]="disabledButton"
        >
          <i class="bi bi-arrow-left-right"></i>
          Transferir paquete
        </button>
      </div>
    </form>
  </div>
</div>
